import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-transit-route',

  templateUrl: './transit-route.component.html',

  styleUrls: ['./transit-route.component.css']

})

export class TransitRouteComponent implements OnInit {

  lst_GeoFence: any = [];

  lst_Routes: any = [];

  lst_Search: any = [];

  bEditMode: boolean = false;

  mdl_Request: FormGroup = this._formBuilder.group({

    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),

    iTransitRoute: new FormControl(''),

    strTitle: new FormControl('', Validators.required),

    iSGeoFence: new FormControl('', Validators.required),

    iDGeoFence: new FormControl('', Validators.required),

    iStopTime: new FormControl('', Validators.required),

    iTripTime: new FormControl('', Validators.required),

    _i: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    public _other: OtherService,

    private _router: Router,

  ) { }

  ngOnInit(): void {

    this.getRoutes();

    this.getGeoFence();

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  getGeoFence = async () => {

    let model = this.mdl_Request.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GeoFence = res;

  }

  getRoutes = async () => {

    let model = this.mdl_Request.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TransitRoute_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Routes = res;

    this.lst_Search = res;

  }

  addRequest(item: any = {}, index?: number) {

    if (item.iTransitRoute) {

      this.bEditMode = true;

      Object.keys(item).forEach(key => {

        this.mdl_Request.get(key)?.setValue(item[key])

      })

      this.mdl_Request.get('_i')?.setValue(index);

      $("#addModal").modal("show")

    }

    else {

      this.bEditMode = false;

      this.mdl_Request.patchValue({

        strTitle: '',

        iSGeoFence: '',

        iDGeoFence: '',

        iStopTime: '',

        iTripTime: '',

      });

      $("#addModal").modal("show")

    }

  }

  submitRequest = async () => {

    if (this.mdl_Request.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    if (!this.bEditMode) {

      let model = this.mdl_Request.value;

      this._other.Showspinner()

      let res = JSON.parse((await axios.post(`TransitRoute_Save`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Routes.push(res[0]);

      $("#addModal").modal("hide")

      this._tooltip.showSuccess('با موفقیت ذخیره شد');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._other.Showspinner()

              let res = JSON.parse((await axios.post(`TransitRoute_Edit`, this._other.stringNumberToNumber(this.mdl_Request.value))).data.toString());

              this._other.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Routes[this.mdl_Request.get('_i')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#addModal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }


  }

  removeRoute(item: any, index: number) {

    let model = this._other.stringNumberToNumber({

      ...this.mdl_Request.value,

      iTransitRoute: item.iTransitRoute

    })

    $.confirm({

      title: `آیا از حذف مسیر اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._other.Showspinner();

            const resp = await axios.post('TransitRoute_Delete', model);

            this._other.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            this._tooltip.showSuccess("با موفقیت حذف شد");

            this.lst_Routes.splice(index, 1);

            this.lst_Search.splice(index, 1);

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }

  filter_Result(val: any) {

    this.lst_Routes = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strSGeoFence_strTitle.includes(val.value) ||

        el.strDGeoFence_strTitle.includes(val.value)
    });

    if (val.value.length == 0) {

      this.lst_Routes = this.lst_Search;

    }

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'مسیرهای ترانزیت.xlsx');
  }


}
